import React from "react";
import { TableContainer, Table } from "@material-ui/core";

export default ({ children, classes, ...props }) => {
	return <TableContainer {...props}>{children}</TableContainer>;
};
